import React from 'react';

const FullHr = () => {
  return (
    <hr className="my-6 border-none h-[1px] w-full hr-bg-color" />
  );
};

export default FullHr;
